module.exports = __webpack_public_path__ + "assets/rm_banner.86e6e6f5.jpeg";